let url = ''

const urlMap = {
    '//app5.shouqiev.com': 'https://mall.shouqiev.com', // app5线上
    '//gateway.shouqiev.com': 'https://mall.shouqiev.com', // 线上
    '//pre': 'https://premall.shouqiev.com',// app5预发布
    '//app510': 'https://mall10.51gofunev.com', // app5 10环境
    '//app520': 'https://test-mall.shouqiev.com', // app5 20环境
    '//app410': 'https://mall10.51gofunev.com', // app5 开发、测试159
    '//test-app4': 'https://test-mall.shouqiev.com', // 新测试
    '//test-app5': 'https://test-mall.shouqiev.com', // 新测试
    ':8802': 'https://test-mall.shouqiev.com', // 本地测试
    // ':8802': 'https://premall.shouqiev.com', // 本地测试预发布
    '//app5share.shouqiev.com': 'https://mall.shouqiev.com', // share线上
    '//app5share1.shouqiev.com': 'https://mall.shouqiev.com', // share线上
    '//app5share2.shouqiev.com': 'https://mall.shouqiev.com', // share线上
    '//app5share3.shouqiev.com': 'https://mall.shouqiev.com', // share线上
    '//app5share4.shouqiev.com': 'https://mall.shouqiev.com', // share线上
    '//app5share5.shouqiev.com': 'https://mall.shouqiev.com', // share线上
}

const pageUrl = location.href

for (name in urlMap) {
    if (pageUrl.indexOf(name) > -1) {
        url = urlMap[name]
        break;
    }
}
sessionStorage.gofun_http = url // 为了兼容一些页面的请求，比如pay.vue、details.vue

export default url



// WEBPACK FOOTER //
// src/pages/goTicket_new/url.js